// 在线评估-汇总
<template>
  <div class="prosit-main">
    <div class="prosit-top-line">
      <el-button class="btn-icon-36 btn-icon-36-close" icon="el-icon-close" @click="closeForm()"></el-button>
      <div class="page-title">项目情况表</div>
    </div>
    <div class="prosit-main-box">
      <div class="prosit-main-scroll-box">
        <div class="step-title" @click="showFormA = !showFormA"><b>受理</b> [{{showFormA ? '收起' : '展开'}}]</div>
        <template v-if="showFormA">
          <div class="line-input line-textarea">
            <span class="label-5">项目名称</span>
            <el-input class="input-s5" type="textarea" v-model="projectInfo.entryName" :disabled="category != '受理'"></el-input>
          </div>
          <div class="line-input line-single">
            <span class="label-5">委托部门</span>
            <select class="input-s5" v-model="projectInfo.department" :disabled="category != '受理'">
              <option v-for="item in departmentList1" :key="item.key" :label="item.label" :value="item.label"></option>
            </select>
            <!-- <el-input class="input-s5d2" v-model="projectInfo.department" placeholder="可填写其他部门"></el-input> -->
          </div>
          <div class="line-input line-single">
            <span class="label-5"></span>
            <el-input class="input-s5" v-model="projectInfo.department" :disabled="category != '受理'" placeholder="可填写选项里没有的部门"></el-input>
          </div>
          <div class="line-input line-single">
            <span class="label-5">所在区域</span>
            <select class="input-s5" v-model="projectInfo.projectTeamPersonnel" @change="citySearch(projectInfo.projectTeamPersonnel)" :disabled="category != '受理'">
              <option v-for="item in provinceList" :key="item.value" :label="item.pro" :value="item.pro"></option>
            </select>
          </div>
          <div class="line-input line-single">
            <span class="label-5"></span>
            <select class="input-s5" v-model="projectInfo.projectChecker" :disabled="category != '受理'">
              <option v-for="item in cityList" :key="item.value" :label="item.city || item.area" :value="item.city || item.area"></option>
            </select>
          </div>
          <div class="line-input line-single">
            <span class="label-5"></span>
            <el-input class="input-s5" v-model="projectInfo.area" :disabled="category != '受理'"></el-input>
          </div>
          <div class="line-input line-single">
            <span class="label-5">文件类型</span>
            <select class="input-s5" v-model="projectInfo.fileType" :disabled="category != '受理'">
              <option label="报告书" value="报告书"></option>
              <option label="报告表" value="报告表"></option>
              <option label="登记表" value="登记表"></option>
              <option label="危废许可证" value="危废许可证"></option>
            </select>
          </div>
          <div class="line-input line-single">
            <span class="label-5">行业类别</span>
            <el-input class="input-s5" v-model="projectInfo.nationalEconomy" :disabled="category != '受理'"></el-input>
          </div>
          <div class="line-input line-single">
            <span class="label-5">环评单位</span>
            <el-input class="input-s5" v-model="projectInfo.eiaUnit" :disabled="category != '受理'"></el-input>
          </div>
          <div class="line-input line-single">
            <span class="label-5l2">环评负责人<br>及联系方式</span>
            <el-input class="input-s5" v-model="projectInfo.contactNumber" :disabled="category != '受理'"></el-input>
          </div>
          <div class="line-input line-filelist">
            <span class="label-5">受理材料</span>
            <div class="fileListDiv" v-if="projectInfoFileLists.fileListA.length">
              <!-- <p class="fileItem" v-for="(fileItem, fileIdx) in projectInfoFileLists.fileListA" :key="fileIdx"><img src="https://image.qsyhbgj.com/img-attach.png" width="16px"><a :href="fileItem.url" download>{{ fileItem.urlName }}</a></p> -->
              <p class="fileItem" v-for="(fileItem, fileIdx) in projectInfoFileLists.fileListA" :key="fileIdx"><img src="https://image.qsyhbgj.com/img-attach.png" width="16px"><u @click="downloadFile(fileItem.url)">{{ fileItem.urlName }}</u></p>
            </div>
            <el-input class="input-s5" v-else disabled placeholder="暂无材料"></el-input>
          </div>
          <div class="line-input line-single">
            <span class="label-5">受理时间</span>
            <!-- <el-input class="input-s5d2" type="date" v-model="projectInfo.timeAiD" :disabled="category != '受理'"></el-input>
            <el-input class="input-s5d2" type="time" v-model="projectInfo.timeAiT" :disabled="category != '受理'" step="2"></el-input> -->
            <el-input class="input-s5" v-model="projectInfo.timeA" disabled></el-input>
          </div>
          <div class="line-input line-textarea">
            <span class="label-5">受理意见</span>
            <el-input class="input-s5" type="textarea" v-model="projectInfo.opinionEia" :disabled="category != '受理'"></el-input>
          </div>
          <div class="line-input line-button" v-if="category == '受理'">
            <!-- <el-button class="btn-icon-36 center-btn btn-icon-ed5565" icon="el-icon-back" type="primary" @click="beforeBack"></el-button> -->
            <el-button class="btn-icon-36 center-btn img-icon-save" icon="el-icon-minus" type="primary" @click="beforeSave"></el-button>
            <el-button class="btn-icon-36 center-btn btn-icon-1ab394" icon="el-icon-right" type="primary" @click="setSubMng"></el-button>
          </div>
        </template>
        <div class="step-title" @click="showFormA1 = !showFormA1"><b>待分配</b> [{{showFormA1 ? '收起' : '展开'}}]</div>
        <template v-if="showFormA1">
          <div class="line-input line-single">
            <span class="label-5">分配时间</span>
            <!-- <el-input class="input-s5d2" type="date" v-model="projectInfo.timeA1iD" :disabled="category != '待分配'"></el-input>
            <el-input class="input-s5d2" type="time" v-model="projectInfo.timeA1iT" :disabled="category != '待分配'" step="2"></el-input> -->
            <el-input class="input-s5" v-model="projectInfo.timeA1" disabled></el-input>
          </div>
          <div class="line-input line-textarea">
            <span class="label-5">项目负责人</span>
            <el-input class="input-s5" type="textarea" v-model="projectInfo.opinionA1" :disabled="category != '待分配'"></el-input>
          </div>
          <div class="line-input line-button" v-if="category == '待分配'">
            <el-button class="btn-icon-36 center-btn btn-icon-ed5565" icon="el-icon-back" type="primary" @click="beforeBack"></el-button>
            <el-button class="btn-icon-36 center-btn img-icon-save" icon="el-icon-minus" type="primary" @click="beforeSave"></el-button>
            <el-button class="btn-icon-36 center-btn btn-icon-1ab394" icon="el-icon-right" type="primary" @click="setSubMng"></el-button>
          </div>
        </template>
        <div class="step-title" @click="showFormB = !showFormB"><b>待评估</b> [{{showFormB ? '收起' : '展开'}}]</div>
        <template v-if="showFormB">
          <div class="line-input line-filelist">
            <span class="label-5">会议通知</span>
            <div class="fileListDiv" v-if="projectInfoFileLists.fileListB.length">
              <p class="fileItem" v-for="(fileItem, fileIdx) in projectInfoFileLists.fileListB" :key="fileIdx"><img src="https://image.qsyhbgj.com/img-attach.png" width="16px"><u @click="downloadFile(fileItem.url)">{{ fileItem.urlName }}</u></p>
            </div>
            <el-input class="input-s5" v-else disabled placeholder="暂无材料"></el-input>
          </div>
          <div class="line-input line-single">
            <span class="label-5">上传时间</span>
            <!-- <el-input class="input-s5d2" type="date" v-model="projectInfo.timeBiD" :disabled="category != '待评估'"></el-input>
            <el-input class="input-s5d2" type="time" v-model="projectInfo.timeBiT" :disabled="category != '待评估'" step="2"></el-input> -->
            <el-input class="input-s5" v-model="projectInfo.timeB" disabled></el-input>
          </div>
          <div class="line-input line-textarea">
            <span class="label-5">待评估意见</span>
            <el-input class="input-s5" type="textarea" v-model="projectInfo.opinionEst" :disabled="category != '待评估'"></el-input>
          </div>
          <div class="line-input line-button" v-if="category == '待评估'">
            <el-button class="btn-icon-36 center-btn btn-icon-ed5565" icon="el-icon-back" type="primary" @click="beforeBack"></el-button>
            <el-button class="btn-icon-36 center-btn img-icon-save" icon="el-icon-minus" type="primary" @click="beforeSave"></el-button>
            <el-button class="btn-icon-36 center-btn btn-icon-1ab394" icon="el-icon-right" type="primary" @click="setSubMng"></el-button>
          </div>
        </template>
        <div class="step-title" @click="showFormC = !showFormC"><b>会议通知</b> [{{showFormC ? '收起' : '展开'}}]</div>
        <template v-if="showFormC">
          <div class="line-input line-filelist">
            <span class="label-6">会议通知材料</span>
            <div class="fileListDiv" v-if="projectInfoFileLists.fileListC.length">
              <p class="fileItem" v-for="(fileItem, fileIdx) in projectInfoFileLists.fileListC" :key="fileIdx"><img src="https://image.qsyhbgj.com/img-attach.png" width="16px"><u @click="downloadFile(fileItem.url)">{{ fileItem.urlName }}</u></p>
            </div>
            <el-input class="input-s6" v-else disabled placeholder="暂无材料"></el-input>
          </div>
          <div class="line-input line-single">
            <span class="label-6">会议通知时间</span>
            <!-- <el-input class="input-s6d2" type="date" v-model="projectInfo.timeCiD" :disabled="category != '会议通知'"></el-input>
            <el-input class="input-s6d2" type="time" v-model="projectInfo.timeCiT" :disabled="category != '会议通知'" step="2"></el-input> -->
            <el-input class="input-s6" v-model="projectInfo.timeC" disabled></el-input>
          </div>
          <div class="line-input line-textarea">
            <span class="label-6">会议通知意见</span>
            <el-input class="input-s6" type="textarea" v-model="projectInfo.opinionExa" :disabled="category != '会议通知'"></el-input>
          </div>
          <div class="line-input line-button" v-if="category == '会议通知'">
            <el-button class="btn-icon-36 center-btn btn-icon-ed5565" icon="el-icon-back" type="primary" @click="beforeBack"></el-button>
            <el-button class="btn-icon-36 center-btn img-icon-save" icon="el-icon-minus" type="primary" @click="beforeSave"></el-button>
            <el-button class="btn-icon-36 center-btn btn-icon-1ab394" icon="el-icon-right" type="primary" @click="setSubMng"></el-button>
          </div>
        </template>
        <div class="step-title" @click="showFormD = !showFormD"><b>评估</b> [{{showFormD ? '收起' : '展开'}}]</div>
        <template v-if="showFormD">
          <div class="line-input line-filelist">
            <span class="label-5">评估材料</span>
            <div class="fileListDiv" v-if="projectInfoFileLists.fileListD.length">
              <p class="fileItem" v-for="(fileItem, fileIdx) in projectInfoFileLists.fileListD" :key="fileIdx"><img src="https://image.qsyhbgj.com/img-attach.png" width="16px"><u @click="downloadFile(fileItem.url)">{{ fileItem.urlName }}</u></p>
            </div>
            <el-input class="input-s5" v-else disabled placeholder="暂无材料"></el-input>
          </div>
          <div class="line-input line-single">
            <span class="label-5">评估时间</span>
            <!-- <el-input class="input-s5d2" type="date" v-model="projectInfo.timeDiD" :disabled="category != '评估'"></el-input>
            <el-input class="input-s5d2" type="time" v-model="projectInfo.timeDiT" :disabled="category != '评估'" step="2"></el-input> -->
            <el-input class="input-s5" v-model="projectInfo.timeD" disabled></el-input>
          </div>
          <div class="line-input line-textarea">
            <span class="label-5">评估意见</span>
            <el-input class="input-s5" type="textarea" v-model="projectInfo.opinionEst1" :disabled="category != '评估'"></el-input>
          </div>
          <div class="line-input line-button" v-if="category == '评估'">
            <el-button class="btn-icon-36 center-btn btn-icon-ed5565" icon="el-icon-back" type="primary" @click="beforeBack"></el-button>
            <el-button class="btn-icon-36 center-btn img-icon-save" icon="el-icon-minus" type="primary" @click="beforeSave"></el-button>
            <el-button class="btn-icon-36 center-btn btn-icon-1ab394" icon="el-icon-right" type="primary" @click="setSubMng"></el-button>
          </div>
        </template>
        <div class="step-title" @click="showFormE = !showFormE"><b>审核</b> [{{showFormE ? '收起' : '展开'}}]</div>
        <template v-if="showFormE">
          <div class="line-input line-filelist">
            <span class="label-5">审核材料</span>
            <div class="fileListDiv" v-if="projectInfoFileLists.fileListE.length">
              <p class="fileItem" v-for="(fileItem, fileIdx) in projectInfoFileLists.fileListE" :key="fileIdx"><img src="https://image.qsyhbgj.com/img-attach.png" width="16px"><u @click="downloadFile(fileItem.url)">{{ fileItem.urlName }}</u></p>
            </div>
            <el-input class="input-s5" v-else disabled placeholder="暂无材料"></el-input>
          </div>
          <div class="line-input line-single">
            <span class="label-5">审核时间</span>
            <!-- <el-input class="input-s5d2" type="date" v-model="projectInfo.timeEiD" :disabled="category != '审核'"></el-input>
            <el-input class="input-s5d2" type="time" v-model="projectInfo.timeEiT" :disabled="category != '审核'" step="2"></el-input> -->
            <el-input class="input-s5" v-model="projectInfo.timeE" disabled></el-input>
          </div>
          <div class="line-input line-textarea">
            <span class="label-5">审核意见</span>
            <el-input class="input-s5" type="textarea" v-model="projectInfo.opinionTex" :disabled="category != '审核'"></el-input>
          </div>
          <div class="line-input line-button" v-if="category == '审核'">
            <el-button class="btn-icon-36 center-btn btn-icon-ed5565" icon="el-icon-back" type="primary" @click="beforeBack"></el-button>
            <el-button class="btn-icon-36 center-btn img-icon-save" icon="el-icon-minus" type="primary" @click="beforeSave"></el-button>
            <el-button class="btn-icon-36 center-btn btn-icon-1ab394" icon="el-icon-right" type="primary" @click="setSubMng"></el-button>
          </div>
        </template>
        <div class="step-title" @click="showFormF = !showFormF"><b>审定</b> [{{showFormF ? '收起' : '展开'}}]</div>
        <template v-if="showFormF">
          <div class="line-input line-filelist">
            <span class="label-5">审定材料</span>
            <div class="fileListDiv" v-if="projectInfoFileLists.fileListF.length">
              <p class="fileItem" v-for="(fileItem, fileIdx) in projectInfoFileLists.fileListF" :key="fileIdx"><img src="https://image.qsyhbgj.com/img-attach.png" width="16px"><u @click="downloadFile(fileItem.url)">{{ fileItem.urlName }}</u></p>
            </div>
            <el-input class="input-s5" v-else disabled placeholder="暂无材料"></el-input>
          </div>
          <div class="line-input line-single">
            <span class="label-5">审定时间</span>
            <!-- <el-input class="input-s5d2" type="date" v-model="projectInfo.timeFiD" :disabled="category != '审定'"></el-input>
            <el-input class="input-s5d2" type="time" v-model="projectInfo.timeFiT" :disabled="category != '审定'" step="2"></el-input> -->
            <el-input class="input-s5" v-model="projectInfo.timeF" disabled></el-input>
          </div>
          <div class="line-input line-textarea">
            <span class="label-5">审定意见</span>
            <el-input class="input-s5" type="textarea" v-model="projectInfo.opinionTau" :disabled="category != '审定'"></el-input>
          </div>
          <div class="line-input line-single">
            <span class="label-5">文号</span>
            <el-input class="input-s5" v-model="projectInfo.docNumber" :disabled="category != '审定'"></el-input>
          </div>
          <div class="line-input line-button" v-if="category == '审定'">
            <el-button class="btn-icon-36 center-btn btn-icon-ed5565" icon="el-icon-back" type="primary" @click="beforeBack"></el-button>
            <el-button class="btn-icon-36 center-btn img-icon-save" icon="el-icon-minus" type="primary" @click="beforeSave"></el-button>
            <el-button class="btn-icon-36 center-btn btn-icon-1ab394" icon="el-icon-right" type="primary" @click="setSubMng"></el-button>
          </div>
        </template>
        <div class="step-title" @click="showFormG = !showFormG"><b>存档</b> [{{showFormG ? '收起' : '展开'}}]</div>
        <template v-if="showFormG">
          <div class="line-input line-filelist">
            <span class="label-5">评估报告</span>
            <div class="fileListDiv" v-if="projectInfoFileLists.fileListG1.length">
              <p class="fileItem" v-for="(fileItem, fileIdx) in projectInfoFileLists.fileListG1" :key="fileIdx"><img src="https://image.qsyhbgj.com/img-attach.png" width="16px"><u @click="downloadFile(fileItem.url)">{{ fileItem.urlName }}</u></p>
            </div>
            <el-input class="input-s5" v-else disabled placeholder="暂无材料"></el-input>
          </div>
          <div class="line-input line-filelist">
            <span class="label-5">环评报批稿</span>
            <div class="fileListDiv" v-if="projectInfoFileLists.fileListG2.length">
              <p class="fileItem" v-for="(fileItem, fileIdx) in projectInfoFileLists.fileListG2" :key="fileIdx"><img src="https://image.qsyhbgj.com/img-attach.png" width="16px"><u @click="downloadFile(fileItem.url)">{{ fileItem.urlName }}</u></p>
            </div>
            <el-input class="input-s5" v-else disabled placeholder="暂无材料"></el-input>
          </div>
          <div class="line-input line-filelist">
            <span class="label-5">会议通知</span>
            <div class="fileListDiv" v-if="projectInfoFileLists.fileListB.length">
              <p class="fileItem" v-for="(fileItem, fileIdx) in projectInfoFileLists.fileListB" :key="fileIdx"><img src="https://image.qsyhbgj.com/img-attach.png" width="16px"><u @click="downloadFile(fileItem.url)">{{ fileItem.urlName }}</u></p>
            </div>
            <el-input class="input-s5" v-else disabled placeholder="暂无材料"></el-input>
          </div>
          <div class="line-input line-filelist">
            <span class="label-5">专家组意见</span>
            <div class="fileListDiv" v-if="projectInfoFileLists.fileListG3.length">
              <p class="fileItem" v-for="(fileItem, fileIdx) in projectInfoFileLists.fileListG3" :key="fileIdx"><img src="https://image.qsyhbgj.com/img-attach.png" width="16px"><u @click="downloadFile(fileItem.url)">{{ fileItem.urlName }}</u></p>
            </div>
            <el-input class="input-s5" v-else disabled placeholder="暂无材料"></el-input>
          </div>
          <div class="line-input line-filelist">
            <span class="label-5">签到单</span>
            <div class="fileListDiv" v-if="projectInfoFileLists.fileListG4.length">
              <p class="fileItem" v-for="(fileItem, fileIdx) in projectInfoFileLists.fileListG4" :key="fileIdx"><img src="https://image.qsyhbgj.com/img-attach.png" width="16px"><u @click="downloadFile(fileItem.url)">{{ fileItem.urlName }}</u></p>
            </div>
            <el-input class="input-s5" v-else disabled placeholder="暂无材料"></el-input>
          </div>
          <div class="line-input line-filelist">
            <span class="label-5">其他</span>
            <div class="fileListDiv" v-if="projectInfoFileLists.fileListG5.length">
              <p class="fileItem" v-for="(fileItem, fileIdx) in projectInfoFileLists.fileListG5" :key="fileIdx"><img src="https://image.qsyhbgj.com/img-attach.png" width="16px"><u @click="downloadFile(fileItem.url)">{{ fileItem.urlName }}</u></p>
            </div>
            <el-input class="input-s5" v-else disabled placeholder="暂无材料"></el-input>
          </div>
          <div class="line-input line-single">
            <span class="label-5">存档去向</span>
            <select class="input-s5" v-model="projectInfo.saveDir" :disabled="category != '存档'">
              <option v-for="item in saveDirList" :key="item.key" :label="item.label" :value="item.label"></option>
            </select>
            <!-- <el-input class="input-s5d2" v-model="projectInfo.saveDir" placeholder="可填写"></el-input> -->
          </div>
          <div class="line-input line-single">
            <span class="label-5">存档时间</span>
            <!-- <el-input class="input-s5d2" type="date" v-model="projectInfo.timeGiD" :disabled="category != '存档'"></el-input>
            <el-input class="input-s5d2" type="time" v-model="projectInfo.timeGiT" :disabled="category != '存档'" step="2"></el-input> -->
            <el-input class="input-s5" v-model="projectInfo.timeG" disabled></el-input>
          </div>
          <div class="line-input line-button" v-if="category == '存档'">
            <el-button class="btn-icon-36 center-btn btn-icon-ed5565" icon="el-icon-back" type="primary" @click="beforeBack"></el-button>
            <el-button class="btn-icon-36 center-btn img-icon-save" icon="el-icon-minus" type="primary" @click="beforeSave"></el-button>
            <!-- <el-button class="btn-icon-36 center-btn btn-icon-1ab394" icon="el-icon-right" type="primary" @click="setSubMng"></el-button> -->
          </div>
        </template>
      </div>
    </div>
    <nut-dialog
      @close="setGoBackStepF = false"
      v-if="setGoBackStepF"
      :visible="setGoBackStepF"
      title="退回详情"
      :noFooter="true">
      <div class="prosit-main-box">
        <div class="prosit-main-scroll-box">
          <div class="line-input line-single">
            <span class="label-4">退回至</span>
            <select class="input-s4" v-model="goBackStepInfo.goBackStep">
              <option v-for="item in goBackStepOpts" :key="item.index" :label="item.label" :value="item.sIndex"></option>
            </select>
          </div>
          <div class="line-input line-button">
            <!-- <el-button class="btn-icon-36 center-btn btn-icon-ed5565" icon="el-icon-back" type="primary" @click="doGoBack(goBackStepInfo.goBackStep)"></el-button> -->
            <el-button class="center-btn btn-text" type="primary" @click="doGoBack(goBackStepInfo.goBackStep)">确定</el-button>
          </div>
        </div>
      </div>
    </nut-dialog>
    <nut-dialog
      @close="setGoNextStepF = false"
      v-if="setGoNextStepF"
      :visible="setGoNextStepF"
      title="提交详情"
      :noFooter="true">
      <div class="prosit-main-box">
        <div class="prosit-main-scroll-box">
          <div class="line-input line-single">
            <span class="label-4">提交至</span>
            <select class="input-s4" v-model="goNextStepInfo.goNextStep">
              <option v-for="item in goNextStepOpts" :key="item.index" :label="item.label" :value="item.sIndex"></option>
            </select>
          </div>
          <div class="line-input line-single">
            <span class="label-4">办理人</span>
            <select class="input-s4" v-model="goNextStepInfo.subManager">
              <option v-for="item in employeeOptions" :key="item.value" :label="item.label" :value="item.label"></option>
            </select>
          </div>
          <div class="line-input line-button">
            <!-- <el-button class="btn-icon-36 center-btn btn-icon-ed5565" icon="el-icon-back" type="primary" @click="doGoBack(goBackStepInfo.goBackStep)"></el-button> -->
            <el-button class="center-btn btn-text" type="primary" @click="doGoNext(goNextStepInfo.goNextStep)">确定</el-button>
          </div>
        </div>
      </div>
    </nut-dialog>
  </div>
</template>

<script>
import api from '../../../api/indexForCoe'
export default {
  props: ['category', 'eiaStatusId'],
  // props: ['eiaStatusId'],
  data () {
    return {
      // category: '评估',
      tabType: 'tabA',
      companyName: '',
      categoryList: [
        '受理',
        '待分配',
        '待评估',
        '会议通知',
        '评估',
        '审核',
        '审定',
        '存档'
      ],
      routerList: [
        '/estEia',
        '/estAllocation',
        '/estMeeNotice',
        '/estExaApp',
        '/estEst',
        '/esTexamine',
        '/esTauthorize',
        '/estSave'
      ],
      subMngList: [
        'subordinateManagerA',
        'subordinateManagerA1',
        'subordinateManagerB',
        'subordinateManagerC',
        'subordinateManagerD',
        'subordinateManagerE',
        'subordinateManagerF',
        'subordinateManagerG'
      ],
      opinionList: [
        'opinionEia',
        'opinionA1',
        'opinionEst',
        'opinionExa',
        'opinionEst1',
        'opinionTex',
        'opinionTau',
        ''
      ],
      showFormA: true,
      showFormA1: true,
      showFormB: true,
      showFormC: true,
      showFormD: true,
      showFormE: true,
      showFormF: true,
      showFormG: true,
      phone: sessionStorage.getItem('qs_phone'),
      setGoNextStepF: false,
      goNextStepInfo: {
        goNextStep: '',
        subManager: ''
      },
      goNextStepOpts: [],
      employeeOptions: [],
      setGoBackStepF: false,
      goBackStepInfo: {
        goBackStep: ''
      },
      goBackStepOpts: [],
      provinceList: [],
      cityList: [],
      projectInfo: {
        entryName: '',
        nationalEconomy: '',
        projectTeamPersonnel: '',
        projectChecker: '',
        area: '',
        fileType: '',
        department: '',
        eiaUnit: '',
        contactNumber: '',
        timeAiD: '',
        timeAiT: '',
        timeA: '',
        opinionEia: '',
        timeA1iD: '',
        timeA1iT: '',
        timeA1: '',
        opinionA1: '',
        timeBiD: '',
        timeBiT: '',
        timeB: '',
        opinionEst: '',
        timeCiD: '',
        timeCiT: '',
        timeC: '',
        opinionExa: '',
        timeDiD: '',
        timeDiT: '',
        timeD: '',
        opinionEst1: '',
        timeEiD: '',
        timeEiT: '',
        timeE: '',
        opinionTex: '',
        timeFiD: '',
        timeFiT: '',
        timeF: '',
        opinionTau: '',
        docNumber: '',
        timeGiD: '',
        timeGiT: '',
        timeG: '',
        saveDir: '',
        goBackDataList: []
      },
      projectInfoFileLists: {
        fileListA: [],
        fileListB: [],
        fileListC: [],
        fileListD: [],
        fileListE: [],
        fileListF: [],
        fileListG1: [],
        fileListG2: [],
        fileListG3: [],
        fileListG4: [],
        fileListG5: []
      },
      saveDirList: [],
      departmentList1: [],
      departmentList: ''
    }
  },
  mounted () {
    api.reportReferenceProvince({
      type: 1,
      pid: 0
    }).then(res => {
      this.provinceList = res.data
      console.log('this.provinceList', this.provinceList)
    })
    api.companyNameByEnquiry({
      phoneOne: this.phone
    }).then(res => {
      this.departmentList1 = []
      if (res.data) {
        var departments = res.data.split('，')
        for (var i = 0; i < departments.length; i++) {
          this.departmentList1.push({
            key: i,
            value: '选项' + i,
            label: departments[i]
          })
        }
      }
    })
    // get saveDirList
    this.saveDirList = []
    var saveDirValue = ''
    if (localStorage.getItem('posts') === '' || !localStorage.getItem('posts')) {
      saveDirValue = '领导层，评估人员，环保管理部门，办公室'
    } else {
      saveDirValue = localStorage.getItem('posts')
    }
    var saveDirPosts = saveDirValue.split('，')
    for (var i = 0; i < saveDirPosts.length; i++) {
      this.saveDirList.push({
        key: i,
        label: saveDirPosts[i]
      })
    }
    // /get saveDirList
    this.getFormData()
    this.getEmployees()
  },
  methods: {
    closeForm () {
      this.$emit('closeForm')
    },
    downloadFile (url) {
      window.open(url)
    },
    citySearch (id) {
      if (id !== '') {
        api.reportReferenceProvince({
          type: 1,
          pid: id
        }).then(res => {
          this.cityList = res.dataF
        })
      }
    },
    beforeBack () {
      console.log(this.category)
      var crtIdx = this.categoryList.indexOf(this.category)
      if (crtIdx !== -1) {
        var beforeStepList = []
        // for (var is = 0; is < crtIdx; is++) {
        //   beforeStepList.push({
        //     index: is,
        //     sIndex: is,
        //     label: this.categoryList[is]
        //   })
        // }
        for (var is = 0; is < crtIdx; is++) {
          if (this.projectInfo[this.subMngList[is]]) {
            beforeStepList.push({
              index: is,
              sIndex: is,
              label: this.categoryList[is]
            })
          }
        }
        this.goBackStepOpts = beforeStepList
        this.goBackStepInfo.goBackStep = beforeStepList.length ? beforeStepList[beforeStepList.length - 1].sIndex : ''
        // this.doGoBack(crtIdx - 1)
        this.setGoBackStepF = true
      }
    },
    doGoBack (lastIdx) {
      var crtIdx = this.categoryList.indexOf(this.category)
      var opinionKey = this.opinionList[crtIdx]
      var opinionVal = opinionKey ? this.projectInfo[opinionKey] : ''
      console.log('doGoBack', crtIdx, lastIdx)
      console.log('opinion', opinionKey, opinionVal, this.projectInfo[opinionKey])
      if (!isNaN(lastIdx)) {
        var lastCategory = this.categoryList[lastIdx]
        var lastRouter = this.routerList[lastIdx]
        console.log('doGoBack category', lastCategory)
        var param = {
          id: this.eiaStatusId,
          type: lastCategory
          // goBackDataList: this.getGoBackDataList(lastIdx, crtIdx)
          // goBackDataList: '[]'
        }
        api.cdEiaStatusUpdate(param).then(res => {
          this.addLogger(`退回至${lastCategory}流程`, this.eiaStatusId, opinionVal, lastRouter)
          // this.$router.push(lastRouter)
        })
      }
    },
    beforeSave () {
      this.doSave(this.category)
    },
    doSave (category) {
      console.log('doSave category', category)
      var param = {
        id: this.eiaStatusId,
        type: category,
        entryName: this.projectInfo.entryName || '',
        department: this.projectInfo.department || '',
        projectTeamPersonnel: this.projectInfo.projectTeamPersonnel || '',
        projectChecker: this.projectInfo.projectChecker || '',
        area: this.projectInfo.area || '',
        fileType: this.projectInfo.fileType || '',
        nationalEconomy: this.projectInfo.nationalEconomy || '',
        eiaUnit: this.projectInfo.eiaUnit || '',
        contactNumber: this.projectInfo.contactNumber || '',
        timeA: this.projectInfo.timeAiD && this.projectInfo.timeAiT ? this.projectInfo.timeAiD + ' ' + this.projectInfo.timeAiT : '',
        opinionEia: this.projectInfo.opinionEia || '',
        timeA1: this.projectInfo.timeA1iD && this.projectInfo.timeA1iT ? this.projectInfo.timeA1iD + ' ' + this.projectInfo.timeA1iT : '',
        opinionA1: this.projectInfo.opinionA1 || '',
        timeB: this.projectInfo.timeBiD && this.projectInfo.timeBiT ? this.projectInfo.timeBiD + ' ' + this.projectInfo.timeBiT : '',
        opinionEst: this.projectInfo.opinionEst || '',
        timeC: this.projectInfo.timeCiD && this.projectInfo.timeCiT ? this.projectInfo.timeCiD + ' ' + this.projectInfo.timeCiT : '',
        opinionExa: this.projectInfo.opinionExa || '',
        timeD: this.projectInfo.timeDiD && this.projectInfo.timeDiT ? this.projectInfo.timeDiD + ' ' + this.projectInfo.timeDiT : '',
        opinionEst1: this.projectInfo.opinionEst1 || '',
        timeE: this.projectInfo.timeEiD && this.projectInfo.timeEiT ? this.projectInfo.timeEiD + ' ' + this.projectInfo.timeEiT : '',
        opinionTex: this.projectInfo.opinionTex || '',
        timeF: this.projectInfo.timeFiD && this.projectInfo.timeFiT ? this.projectInfo.timeFiD + ' ' + this.projectInfo.timeFiT : '',
        opinionTau: this.projectInfo.opinionTau || '',
        docNumber: this.projectInfo.docNumber || '',
        timeG: this.projectInfo.timeGiD && this.projectInfo.timeGiT ? this.projectInfo.timeGiD + ' ' + this.projectInfo.timeGiT : '',
        saveDir: this.projectInfo.saveDir || ''
      }
      api.cdEiaStatusUpdate(param).then(res => {
        // this.$message({
        //   message: '保存成功',
        //   type: 'success'
        // })
        this.$toast.text('保存成功')
        this.getFormData()
        this.$emit('getTabData')
      })
    },
    setSubMng () {
      // this.setGoNextStepF = true
      this.beforeNext()
    },
    beforeNext () {
      var crtIdx = this.categoryList.indexOf(this.category)
      console.log(this.category, crtIdx)
      if (crtIdx !== -1) {
        var beforeStepList = []
        // for (var is = crtIdx + 1; is < this.categoryList.length; is++) {
        //   if (this.projectInfo[this.subMngList[is]]) {
        //     beforeStepList.push({
        //       index: is,
        //       sIndex: is,
        //       label: this.categoryList[is]
        //     })
        //   }
        // }
        for (var is = crtIdx + 1; is < this.categoryList.length; is++) {
          beforeStepList.push({
            index: is,
            sIndex: is,
            label: this.categoryList[is]
          })
        }
        this.goNextStepOpts = beforeStepList
        this.goNextStepInfo.goNextStep = beforeStepList.length ? beforeStepList[0].sIndex : ''
        // this.doGoNext(crtIdx + 1)
        this.setGoNextStepF = true
      }
    },
    doGoNext (nextIdx) {
      var nextCategory = this.categoryList[nextIdx]
      var nextRouter = this.routerList[nextIdx]
      var nextSubMng = this.subMngList[nextIdx]
      console.log('doGoBack category', nextCategory)
      var crtIdx = this.categoryList.indexOf(this.category)
      var opinionKey = this.opinionList[crtIdx]
      var opinionVal = opinionKey ? this.projectInfo[opinionKey] : ''
      console.log('opinion', opinionKey, opinionVal, this.projectInfo[opinionKey])
      var param = {
        id: this.eiaStatusId,
        type: nextCategory
      }
      param[nextSubMng] = this.goNextStepInfo.subManager
      console.log('cdEiaStatusUpdate', param)
      if (this.goNextStepInfo.subManager) {
        api.cdEiaStatusUpdate(param).then(res => {
          this.addLogger(`提交至${nextCategory}流程，设置办理人为${this.goNextStepInfo.subManager}`, this.eiaStatusId, opinionVal, nextRouter)
          // this.$router.push(nextRouter)
        })
      } else {
        // this.$message({
        //   message: '请选择下级办理人',
        //   type: 'warning'
        // })
        this.$toast.text('请选择下级办理人')
      }
    },
    getEmployees () {
      api.cdEiaStatusAllUsers({
        staffing: 1,
        phone: this.phone,
        pages: 1000,
        pageNo: 1
      }).then(res => {
        var tempArr = []
        res.data.list.forEach(item => {
          tempArr.push({
            value: item.id,
            label: item.name
          })
        })
        this.employeeOptions = tempArr
      })
    },
    getFormData (pageNo = 1) {
      api.cdEiaStatusEnquiry({
        phone: this.phone,
        id: this.eiaStatusId
      }).then(res => {
        console.log(res)
        var tempObj = {
          entryName: res.data.entryName || '',
          nationalEconomy: res.data.nationalEconomy || '',
          projectTeamPersonnel: res.data.projectTeamPersonnel || '',
          projectChecker: res.data.projectChecker || '',
          area: res.data.area || '',
          fileType: res.data.fileType || '',
          department: res.data.department || '',
          eiaUnit: res.data.eiaUnit || '',
          contactNumber: res.data.contactNumber || '',
          timeAiD: res.data.timeA ? res.data.timeA.split(' ')[0] : '',
          timeAiT: res.data.timeA ? res.data.timeA.split(' ')[1] : '',
          timeA: res.data.timeA || '',
          opinionEia: res.data.opinionEia || '',
          subordinateManagerA: res.data.subordinateManagerA || '',
          timeA1iD: res.data.timeA1 ? res.data.timeA1.split(' ')[0] : '',
          timeA1iT: res.data.timeA1 ? res.data.timeA1.split(' ')[1] : '',
          timeA1: res.data.timeA1 || '',
          opinionA1: res.data.opinionA1 || '',
          subordinateManagerA1: res.data.subordinateManagerA1 || '',
          timeBiD: res.data.timeB ? res.data.timeB.split(' ')[0] : '',
          timeBiT: res.data.timeB ? res.data.timeB.split(' ')[1] : '',
          timeB: res.data.timeB || '',
          opinionEst: res.data.opinionEst || '',
          subordinateManagerB: res.data.subordinateManagerB || '',
          timeCiD: res.data.timeC ? res.data.timeC.split(' ')[0] : '',
          timeCiT: res.data.timeC ? res.data.timeC.split(' ')[1] : '',
          timeC: res.data.timeC || '',
          opinionExa: res.data.opinionExa || '',
          subordinateManagerC: res.data.subordinateManagerC || '',
          timeDiD: res.data.timeD ? res.data.timeD.split(' ')[0] : '',
          timeDiT: res.data.timeD ? res.data.timeD.split(' ')[1] : '',
          timeD: res.data.timeD || '',
          opinionEst1: res.data.opinionEst1 || '',
          subordinateManagerD: res.data.subordinateManagerD || '',
          timeEiD: res.data.timeE ? res.data.timeE.split(' ')[0] : '',
          timeEiT: res.data.timeE ? res.data.timeE.split(' ')[1] : '',
          timeE: res.data.timeE || '',
          opinionTex: res.data.opinionTex || '',
          subordinateManagerE: res.data.subordinateManagerE || '',
          timeFiD: res.data.timeF ? res.data.timeF.split(' ')[0] : '',
          timeFiT: res.data.timeF ? res.data.timeF.split(' ')[1] : '',
          timeF: res.data.timeF || '',
          opinionTau: res.data.opinionTau || '',
          subordinateManagerF: res.data.subordinateManagerF || '',
          docNumber: res.data.docNumber || '',
          timeGiD: res.data.timeG ? res.data.timeG.split(' ')[0] : '',
          timeGiT: res.data.timeG ? res.data.timeG.split(' ')[1] : '',
          timeG: res.data.timeG || '',
          saveDir: res.data.saveDir || '',
          subordinateManagerG: res.data.subordinateManagerG || ''
          // goBackDataList: JSON.parse(res.data.goBackDataList || '[]')
        }
        this.projectInfo = tempObj
        console.log('projectInfo', this.projectInfo)
        api.reportReferenceProvince({
          type: 1,
          pid: res.data.projectTeamPersonnel
        }).then(res => {
          this.cityList = res.dataF
        })
      })
      api.cdEiaEnclosureAllEnquiry({
        phone: this.phone,
        eiaStatusId: this.eiaStatusId
      }).then(res => {
        var tempObj = {
          fileListA: res.data.list1,
          fileListB: res.data.list2,
          fileListC: res.data.list3,
          fileListD: res.data.list4,
          fileListE: res.data.list5,
          fileListF: res.data.list6,
          fileListG1: res.data.list71,
          fileListG2: res.data.list72,
          fileListG3: res.data.list73,
          fileListG4: res.data.list74,
          fileListG5: res.data.list75
        }
        this.projectInfoFileLists = tempObj
        console.log('projectInfoFileLists', this.projectInfoFileLists)
      })
    },
    addLogger (str, addId, opinion, pushRouter) {
      var param = {
        superiorId: addId,
        operator: this.phone,
        operationType: this.category,
        operationDetails: str,
        operationOpinion: opinion || ''
      }
      api.cdEiaJournalAdd(param).then(res => {
        console.log(res)
        // this.$router.push(pushRouter)
        this.$emit('closeForm', pushRouter)
      })
    },
    // old
    getTabData (pageNo = 1) {
      if (this.tabDataCrt.tabType === 'table') {
        api[this.tabDataCrt.api.enquiry]({
          pageNo: pageNo,
          pages: 10,
          ...this.tabDataCrt.api.extraParam
        }).then(res => {
          console.log(res)
          this.totalNumber = res.data.totalNumber
          var tempArr = []
          res.data.list.forEach(item => {
            var arrPusher = {
              id: item.id,
              editFlag: false
            }
            this.tabDataCrt.rowItems.forEach(rowItem => {
              arrPusher[rowItem] = item[rowItem] || ''
            })
            tempArr.push(arrPusher)
          })
          this.tabDataCrt.tableData = tempArr
          console.log(this.tabDataCrt.tableData)
        })
      } else if (this.tabDataCrt.tabType === 'multiform') {
      }
    },
    handleRefresh () {
      this.getTabData()
    },
    table_index (index) {
      return (this.pageNo - 1) * this.pages + index + 1
    },
    handleCurrentChange (pageNo) {
      this.pageNo = pageNo
      this.getTabData(this.pageNo)
    },
    // closeIF () {
    //   this.importFlag = false
    // },
    // addRow () {
    //   this.importFlag = true
    // },
    // handleSuccess () {
    //   this.$toast.text('上传成功')
    //   this.getTabData()
    // },
    // checkUpload () {
    //   this.$refs.uploadRef.doUpload()
    // },
    // closeWI () {
    //   this.wordInfo = false
    // },
    // addTerm () {
    //   this.wordInfo = true
    // },
    // editRow (row) {
    //   // row.editFlag = true
    //   this.percentage = 0
    //   this.jindu = true
    //   var bianliang = setInterval(() => {
    //     this.percentage = this.percentage + 1
    //     if (this.percentage >= 99) {
    //       clearInterval(bianliang)
    //     }
    //   }, 1000)
    //   api.cdSummaryTableDownload({
    //     id: row.id
    //   }).then(res => {
    //     console.log(res)
    //     if (res.code === 200) {
    //       window.open(res.data)
    //       this.percentage = 100
    //       clearInterval(bianliang)
    //       setTimeout(() => {
    //         this.jindu = false
    //       }, 1000)
    //     } else {
    //       clearInterval(bianliang)
    //       this.text1 = res.message
    //     }
    //     // if (res.code === 40001) {
    //     //   this.jindu = false
    //     // }
    //   })
    // },
    // saveRow (row) {
    //   if (this.tabDataCrt.tabType === 'table') {
    //     var savePusher = {
    //       id: row.id,
    //       ...this.tabDataCrt.api.extraParam
    //     }
    //     this.tabDataCrt.rowItems.forEach(rowItem => {
    //       console.log(row, rowItem, row[rowItem])
    //       savePusher[rowItem] = row[rowItem] || ''
    //     })
    //     api[this.tabDataCrt.api.update](savePusher).then(res => {
    //       console.log(res)
    //       this.$nextTick(() => {
    //         this.isRefresh = true
    //         this.pageNo = 1
    //         this.getTabData()
    //       })
    //     })
    //   }
    // },
    deleteRow (row) {
      if (this.tabDataCrt.tabType === 'table') {
        api[this.tabDataCrt.api.delete]({
          id: row.id
        }).then(res => {
          console.log(res)
          this.$nextTick(() => {
            this.isRefresh = true
            this.pageNo = 1
            this.getTabData()
          })
        })
      }
    },
    showDetails (row) {
      console.log(row)
      this.detailsRow = row
      this.showDetailsDialogFlag = true
    },
    proSitTable (row) {
      this.showProSitFormFlag = true
    },
    closeProSitForm () {
      this.showProSitFormFlag = false
    },
    showStatistics () {
      this.showStatisticsFlag = true
      this.getStatisticsTable()
    },
    getStatisticsTable () {
      api[this.tableStat.api.enquiry]({
        ...this.tableStat.api.extraParam
      }).then(res => {
        console.log(res)
        var tempArr = []
        res.data.list.forEach(item => {
          var arrPusher = {
            id: item.id
          }
          this.tableStat.rowItems.forEach(rowItem => {
            arrPusher[rowItem] = item[rowItem]
          })
          tempArr.push(arrPusher)
        })
        this.tableStat.tableData = tempArr
        console.log(this.tableStat.tableData)
      })
    }
  },
  components: {
  }
}
</script>

<style lang="scss">
.prosit-main {
  z-index: 0;
  height: 100%;
  overflow-y: auto;
  .prosit-top-line {
    background: #f3f4f5;
    height: 56px;
    .page-title {
      font-family: "Microsoft Yahei","Hiragino Sans GB","Helvetica Neue",Helvetica,tahoma,arial,"WenQuanYi Micro Hei",Verdana,sans-serif;
      height: 100%;
      font-size: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #000;
    }
    .btn-icon-36-close {
      position: absolute;
      // left: 10px;
      top: 10px;
      z-index: 99;
    }
  }
  .mainTable{
    margin: 10px;
    width: calc(100% - 20px);
    word-break: break-all;
    .tableFileCell{
      text-decoration: underline;
      color: #00C;
    }
    .tableFileCell:hover{
      color: #66F;
      text-decoration: none;
    }
    .cell{
      border: 1px #ccc solid;
      text-align: center;
    }
    .thtitle{
      background-color: #fafafa;
      line-height: 24px;
    }
    .tdcell{
      background-color: #fff;
      line-height: 32px;
      padding: 2px;
      .el-input__inner{
        height: 28px!important;
      }
      .text-btn {
        margin: 0!important;
      }
    }
  }
  .bottom-pagination .el-pagination {
    text-align: right;
    margin-top: 6px;
    margin-bottom: 6px;
  }
  .details-dialog-main{
    table {
      word-break: break-all;
      width: 100%;
      height: 100%;
      border-top: 1px #999 solid;
      border-left: 1px #999 solid;
      th {
        color: #000;
      }
      th, td {
        padding: 12px 0;
        color: #333;
        border-right: 1px #999 solid;
      }
      th {
        border-bottom: 1px #999 solid;
      }
      td {
        border-bottom: 1px #999 solid;
      }
    }
  }
}
</style>
